export default function AboutSection() {
  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <img
            src="https://readdy.ai/api/search-image?query=A%20flatlay%20topdown%20composition%20of%20a%20laptop%20with%20spreadsheet%20grid%20interface%20surrounded%20by%20fashion%20items%20shoes%20sunglasses%20wallet%20and%20a%20steaming%20coffee%20cup%20on%20a%20warm%20cream%20desk%20surface%20with%20scattered%20product%20tags%20and%20a%20color%20palette%20swatch%20clean%20organized%20creative%20workspace%20aesthetic%20editorial%20still%20life%20photography&width=800&height=400&seq=about-illustration-v2&orientation=landscape"
            alt="Superbuy Spreadsheet illustrated concept showing organized product discovery workspace"
            title="What Is Superbuy Spreadsheet"
            className="w-full max-w-[600px] h-auto object-cover rounded-2xl mb-12"
          />
          <p className="text-foreground-500 text-sm font-medium tracking-widest uppercase mb-4">Understanding the Basics</p>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-6">
            What Is Superbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-[750px] leading-relaxed">
            A <strong>Superbuy Spreadsheet</strong> is an organized resource system that helps shoppers discover products, compare information and research items before purchasing through shopping agents. Instead of spending hours searching manually, users can explore categorized product information in a structured format — making the entire discovery process faster, smarter, and more enjoyable.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full max-w-[900px] mx-auto border-collapse">
            <thead>
              <tr className="border-b border-background-300/50">
                <th className="text-left py-4 px-5 text-foreground-500 text-sm font-medium">Feature</th>
                <th className="text-left py-4 px-5 text-foreground-400 text-sm font-medium">Normal Searching</th>
                <th className="text-left py-4 px-5 text-primary-600 text-sm font-semibold">Superbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', normal: 'Time consuming', superbuy: 'Organized' },
                { feature: 'Category Browsing', normal: 'Difficult', superbuy: 'Simple' },
                { feature: 'Research Speed', normal: 'Slow', superbuy: 'Faster' },
                { feature: 'Product Comparison', normal: 'Manual', superbuy: 'Structured' },
                { feature: 'Buyer Planning', normal: 'Limited', superbuy: 'Improved' },
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200/40">
                  <td className="py-4 px-5 text-foreground-800 text-sm font-medium">{row.feature}</td>
                  <td className="py-4 px-5 text-foreground-500 text-sm">{row.normal}</td>
                  <td className="py-4 px-5">
                    <span className="inline-flex items-center gap-1 text-primary-600 text-sm font-medium">
                      <i className="ri-check-line text-xs"></i>
                      {row.superbuy}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}